import React, { useEffect, useMemo, useState } from "react";
import { Box, Grid, Tab, Tabs } from "@material-ui/core";
import { getTasksListing } from "../../data/services/API";
import _, { set } from "lodash";

import { makeStyles } from "@material-ui/core/styles";
import Popper from "@material-ui/core/Popper";
import InputBase from "@material-ui/core/InputBase";
import Divider from "@material-ui/core/Divider";
import IconButton from "@material-ui/core/IconButton";
import SearchIcon from "@material-ui/icons/Search";
import HighlightOff from "@material-ui/icons/HighlightOff";
import CloseIcon from "@material-ui/icons/Close";
import { TASK_OPTIONS } from "../../utils/constants";

const useStyles = makeStyles((theme) => ({
  root: {
    padding: "2px 4px",
    display: "flex",
    alignItems: "center",
    width: "100%",
  },
  input: {
    marginLeft: theme.spacing(1),
    flex: 1,
  },
  iconButton: {
    padding: 10,
  },
  divider: {
    height: 28,
    margin: 4,
  },
}));

const TaskPopperUi = (props) => {
  const classes = useStyles();
  const {
    open,
    anchorEl,
    ref,
    setTaskSelectedFromList,
    setShowTasksPopper,
    setClickedAddBtnNode,
    addTask,
  } = props;

  var elementName = "#" + anchorEl + ".addbtn";
  var element = document.querySelector(elementName);
  var modalElement = document.querySelector(".custom_popper_content");

  const [tabValue, setTabValue] = useState("All");
  // const [taskArrayForSelectListing, setTaskArrayForSelectListing] = useState(
  //   []
  // );
  const [taskArrayForSelectListing, setTaskArrayForSelectListing] = useState([]);
  const [tabsToDisplay, setTabsToDisplay] = useState([]);
  const [searchValue, setSearchValue] = useState("");
  const [addTaskPosition, setAddTaskPosition] = useState(null);
  const [modalHeight, getModalHeight] = useState(null);
  const [modalWidth, getModalWidth] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  // task: "SIMPLE"
  // ​​​
  // type: "SYSTEM"

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  const handleSearch = (event) => {
    const { value } = event.target;
    setSearchValue(value);
  };

  const handleClearSearch = () => {
    setSearchValue("");
  };

  const tasksToDisplay = useMemo(() => {
    switch (tabValue) {


      case "CUSTOM":
        const cust = taskArrayForSelectListing.filter(
          (task) => task.type === 'SYSTEM'
          // (task) => task.type === tabValue
        );
        return cust;

      case "SYSTEM":
        const sys = taskArrayForSelectListing.filter(
          (task) => task.type === 'CUSTOM'
          // (task) => task.type === tabValue
        );
        return sys;

      default:
        return taskArrayForSelectListing;
    }
  }, [tabValue, taskArrayForSelectListing]);

  const searchedTaskList = useMemo(() => {
    const taskList = searchValue
      ? tasksToDisplay.filter((ele) => {
        const item = ele.task.split('_').join(' ');
        return item.toLowerCase().includes(searchValue.toLowerCase())
      }
      )
      : tasksToDisplay;
    return taskList;
  }, [searchValue, tasksToDisplay]);

  const handleTaskClick = (selectedTask) => {
    addTask(selectedTask);
    // setTaskSelectedFromList({ selectedTask, ref: anchorEl });
    // setClickedAddBtnNode("");
    // setShowTasksPopper(false);
  };

  useEffect(() => {
    (async () => {
      try {
        setIsLoading(true);
        const resp = await getTasksListing();

        const { data } = resp;
        const tabs = data.length
          ? _.union(_.compact(data.map((tab) => tab.type)))
          : [];

        data.sort((a, b) => a.task.localeCompare(b.task));
        setIsLoading(false);
        setTaskArrayForSelectListing(data);
        setTabsToDisplay(["All", ...tabs]);
      } catch (error) {
        setIsLoading(false);
        if (error.response) console.log(error.response);
      }
    })();

    return () => { };
  }, []);

  useEffect(() => {
    if (element) {
      const rect = element.getBoundingClientRect();
      setAddTaskPosition(rect);
    }
    if (modalElement) {
      const modalHeight = modalElement.clientHeight;
      const modalWidth = modalElement.clientWidth;
      getModalHeight(modalHeight);
      getModalWidth(modalWidth);
    }
  }, [element, modalElement]);

  return (
    <div id="custom_modal" className="custom_modal">

      <Box
        id="custom_modal-content"
        className="custom_popper_content"
        style={{
          top: `${addTaskPosition ? addTaskPosition.bottom + 0.5 * modalHeight : 340
            }px`,
          left: `${addTaskPosition ? addTaskPosition.left + 0.5 * modalWidth : 340
            }px`,
          // top: `${addTaskPosition?addTaskPosition.bottom:340}px`,
          // left: `${addTaskPosition?addTaskPosition.left:340}px`,
        }}>
        <Box className="custom_popper_header">
          <Grid
            container
            spacing={2}
            alignItems="flex-end"
            justifyContent="center">
            <Grid item xs={10}>
              <Box className="custom_popper_header__title">Add Task</Box>
            </Grid>
            <Grid item xs={2}>
              {/* Close button */}
              <IconButton
                color="primary"
                className={classes.iconButton}
                aria-label="close"
                onClick={() => setShowTasksPopper(false)} // Function to close the popper
              >
                <CloseIcon />
              </IconButton>
            </Grid>
            <Grid item xs={12}>
              <Box
                component="form"
                className={`${classes.root} custom_popper_header__searchbox`}>
                <SearchIcon />
                <InputBase
                  className={classes.input}
                  placeholder="Filter tasks"
                  inputProps={{
                    "aria-label": "Filter tasks",
                    variant: "outlined",
                  }}
                  value={searchValue}
                  onChange={handleSearch}
                />
                <Divider className={classes.divider} orientation="vertical" />
                <IconButton
                  color="primary"
                  className={classes.iconButton}
                  aria-label="directions"
                  onClick={handleClearSearch}>
                  <HighlightOff />
                </IconButton>
              </Box>
            </Grid>
          </Grid>
        </Box>
        {isLoading ? (
          <div style={{ textAlign: "center", paddingTop: "20px", }}>Loading...</div>
        ) : (
          <Box className="custom_popper_task-tab">
            <Tabs
              value={tabValue}
              onChange={handleTabChange}
              variant="scrollable"
              scrollButtons="off"
              aria-label="scrollable auto tabs example">
              {/* <Tab label="All" value="all" /> */}
              {tabsToDisplay.map((tab, i) => (
                <Tab label={tab} value={tab} key={`${tab}-${i}`} />
              ))}
            </Tabs>
          </Box>
        )}
        <Box className="custom_popper_taskmenu">
          <div className="">
            {searchedTaskList && searchedTaskList.length
              ? searchedTaskList.map((task) => (
                <Box
                  id={`${task.type}-${task.task}`}
                  key={`${task.type}-${task.task}`}
                  className="custom_popper_taskmenu-task"
                  onClick={() => handleTaskClick(task)}>
                  <div className="custom_popper_taskmenu-task__element_name">
                    {task.task
                      .split("_")
                      .map((el) => _.capitalize(el))
                      .join(" ")}
                  </div>
                </Box>
              ))
              : ""}
          </div>
        </Box>
      </Box>
    </div>
  );
};

export default TaskPopperUi;
